export function formatHeader(header) {
  if (!header) return [];

  const newHeaders = {};
  header.forEach(item => {
    if (item.parent === null) {
      newHeaders[item.id] = { ...item, children: [] };
    } else {
      const parentId = item.parent;
      if (!newHeaders[parentId]) {
        newHeaders[parentId] = { id: parentId, children: [] };
      }
      newHeaders[parentId].children.push(item);
    }
  });

  Object.values(newHeaders).forEach(item => {
    item.children = item.children.filter(child => child.title && child.route);
  });

  const result = Object.values(newHeaders).filter(item => item.title && item.route);

  return result;
}

export function formPath(headers, title){
  const path = [];
  let currentPage = headers.find(header => header.title === title);

  while (currentPage) {
    path.push(currentPage);
    currentPage = headers.find(header => header.id === currentPage.parent);
  }
  return path.reverse();
}